import apiClient from '../utils/apiClient';

/**
 * Connected services — one wrapper for every engine.
 *
 * A service is named by its registry key ('esign', ...), so adding an engine
 * adds no code here. Every engine call rides the server-side passthrough:
 * the browser names a path, the server checks it against that service's
 * allowlist and attaches the facility's key. A key never reaches this file.
 */
const base = (service) => `/api/engines/${service}`;

const enginesService = {
  /** Every service and whether this facility has wired it. */
  list: (facilityId) =>
    apiClient.get('/api/engines', { params: { facility_id: facilityId } }),

  /** Light status for the card — never calls the engine. */
  connection: (service, facilityId) =>
    apiClient.get(`${base(service)}/panel/connection`, {
      params: { facility_id: facilityId },
    }),

  /**
   * Connect or re-verify. Send only what was typed: a blank credential
   * means "keep the stored one", so changing just the URL never wipes a key.
   */
  connect: (service, facilityId, { engineUrl, apiKey, webhookSecret }) =>
    apiClient.post(`${base(service)}/panel/connect`, {
      facility_id: facilityId,
      ...(engineUrl ? { engine_url: engineUrl } : {}),
      ...(apiKey ? { api_key: apiKey } : {}),
      ...(webhookSecret ? { webhook_secret: webhookSecret } : {}),
    }),

  disconnect: (service, facilityId) =>
    apiClient.delete(`${base(service)}/panel/connection`, {
      params: { facility_id: facilityId },
    }),

  /** The URL the service frame loads. Short-lived and single-use. */
  frameSession: (service, facilityId) =>
    apiClient.post(`${base(service)}/panel/frame-session`, null, {
      params: { facility_id: facilityId },
    }),

  /** Any allowlisted engine path, through the passthrough. */
  engine: (service, facilityId, method, path, body) =>
    apiClient.request({
      method,
      url: `${base(service)}/panel/engine/${path}`,
      params: { facility_id: facilityId },
      ...(body !== undefined ? { data: body } : {}),
    }),
};

export default enginesService;
